/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  IndexTable,
  LegacyCard,
  IndexFilters,
  useSetIndexFiltersMode,
  Text,
  Badge,
  Page,
  Button,
  BlockStack,
  ChoiceList,
  TextField,
  DatePicker,
  IndexFiltersMode,
  Select,
  Banner,
  Combobox,
  Listbox,
  Icon,
  AutoSelection,
  SkeletonDisplayText,
} from "@shopify/polaris";
import {
  AlertTriangleIcon,
  PersonIcon,
  SearchIcon,
  ExportIcon,
} from "@shopify/polaris-icons";
import dayjs from "dayjs";
import { useState, useCallback, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import formatDate from "../hooks/useDate";
import CancelBooking from "../components/atoms/CancelBooking";
import ModalComponent from "../components/atoms/Modal";
import {
  useAiFilterGeneratorMutation,
  useBulkFulfillmentMutation,
  useFetchOrdersQuery,
} from "../store/store/slices/OrderRTK";
import AppModal from "../components/atoms/Popup";
import "./../styles/Filter.css";
import { removeEmptyElements } from "../utils/helpers";
import { useGetChildAccountsWithLimitedDataQuery, useGetUsersQuery } from "../store/store/slices/UsersRTK";
import { UserListFiltersType, UserStr } from "../store/types/Orders";
import { recordsTypes } from "../store/types/types";
import RefreshButton from "../components/atoms/RefreshButton";
import GeneralPagination from "../components/atoms/Pagination";
import ExportOrderModal from "../components/atoms/ExportOrderModal";
import { showToast } from "../store/store/slices/AlertSlice";
import GenerateButton from "../components/atoms/AiButton";
import { useGetUserQuery } from "../store/store/slices/ProfileRTK";

type ParseError = {
  type: string;
  code: string;
  message: string;
  row?: number;
};

type CsvProcessingResult = {
  fileName: string;
  fileSize: number;
  lastModified: number;
  jsonData: Record<string, unknown>[];
  rawData: string;
  parseErrors: ParseError[];
  isValid: boolean;
};

export default function IndexFiltersDefaultExample() {
  const [
    bulkFulfillment,
    {
      isLoading: bulkFulfillmentLoading,
      isError: bulkFulfillmentFailed,
      isSuccess: bulkFullfillmentSuccess,
      data: bulkFullFillmentData,
    },
  ] = useBulkFulfillmentMutation();

  const dispatch = useDispatch();

  const { data: childAccounts, isSuccess: accountsFetched } =
    useGetUsersQuery<any>({});
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const appliedFilters: any = [];
  
  const navigateTo = useNavigate();
  const [cod, setCod] = useState("");
  const [trackId, setTrackId] = useState("");
  const [selected, setSelected] = useState(0);
  const [status, setStatus] = useState<string[]>(
    params.get("status")?.split(",") || []
  );
  const [paymentStatus, setPaymentStatus] = useState<string[]>(
    params.get("payment_status")?.split(",") || []
  );
  const [courier, setCourier] = useState<string[]>(
    params.get("courier")?.split(",") || []
  );
  const [queryValue, setQueryValue] = useState("");
  const [isAiMode, setIsAiMode] = useState(false);
  const [queryPlaceholder, setQueryPlaceholder] = useState(
    "Search by order id, tracking number, destination city, status and type e.g 'merged'"
  );
  const [modalOpen, setModalOpen] = useState(false);
  const [showSuggestions, setShowSuggestions] = useState(false);
  
  // Hardcoded suggestions with their responses
  const suggestions = [
    { text: "orders with fulfilled status", response: "Filters orders with FULFILLED status" },
    { text: "orders with paid payment status", response: "Filters orders with PAID payment status" },
    { text: "orders from last week", response: "Filters orders booked in the last 7 days" },
    { text: "orders with COD amount greater than 5000", response: "Filters orders with COD greater than 5000" },
    { text: "orders delivered in last 7 days", response: "Filters orders delivered in the last week" },
    { text: "orders with cancelled status", response: "Filters orders with CANCELLED status" },
    { text: "orders from LEOPARD courier", response: "Filters orders from LEOPARD courier" },
    { text: "orders booked in last month", response: "Filters orders booked in the last 30 days" },
    { text: "orders with delivery days greater than 5", response: "Filters orders with delivery days > 5" },
    { text: "orders to Karachi city", response: "Filters orders to Karachi destination" },
  ];
  const [bookedBy, setBookedBy] = useState<string[]>(
    params?.get("bookedBy")?.split(",") || []
  );
  const [deliveryDaysOp, setDeliveryDaysOp] = useState("");
  const [sortSelected, setSortSelected] = useState(["order desc"]);
  const [dest, setDestination] = useState(params.get("dest") || "");
  const [track_number, setTrackNumber] = useState(params.get("track") || "");
  const [deliveryDays, setDeliveryDays] = useState(params.get("days") || "");
  const { mode, setMode } = useSetIndexFiltersMode(IndexFiltersMode.Filtering);
  const [phoneNumber, setPhoneNumber] = useState(params.get("phone_num") || "");
  const [tag, setTag] = useState<string[]>(params.get("tag")?.split(",") || []);
  const [openExportOrdersModal, setOpenExportOrdersModal] =
    useState<boolean>(false);
  const bookingFromParam = params.get("bookingfrom");
  const bookingToParam = params.get("bookingto");
  let restoredBookingDates = null;

  if (bookingFromParam && bookingToParam) {
    const start = new Date(bookingFromParam);
    const end = new Date(bookingToParam);
    if (!isNaN(start.getTime()) && !isNaN(end.getTime())) {
      restoredBookingDates = { start, end };
    }
  }

  const [selectedDates, setSelectedDates] = useState<any>(restoredBookingDates);

  const [{ month, year }, setDate] = useState<any>({
    month: restoredBookingDates?.start
      ? restoredBookingDates.start.getMonth()
      : new Date().getMonth(),
    year: restoredBookingDates?.start
      ? restoredBookingDates.start.getFullYear()
      : new Date().getFullYear(),
  });

  const deliveredFromParam = params.get("deliveredfrom");
  const deliveredToParam = params.get("deliveredto");
  let restoredDeliveryDates = null;

  if (deliveredFromParam && deliveredToParam) {
    const start = new Date(deliveredFromParam);
    const end = new Date(deliveredToParam);
    if (!isNaN(start.getTime()) && !isNaN(end.getTime())) {
      restoredDeliveryDates = { start, end };
    }
  }

  const [selectedDeliveryDates, setSelectedDeliveryDates] = useState<any>(
    restoredDeliveryDates
  );

  const [{ month: dmonth, year: dyear }, setDelivery] = useState({
    month: restoredDeliveryDates?.start
      ? restoredDeliveryDates.start.getMonth()
      : new Date().getMonth(),
    year: restoredDeliveryDates?.start
      ? restoredDeliveryDates.start.getFullYear()
      : new Date().getFullYear(),
  });
  const deselectedOptions = accountsFetched
    ? childAccounts?.map((user: UserListFiltersType) => ({
        label: user?.first_name + " " + user?.last_name,
        value: user?._id,
      }))
    : [];
  const [inputValue, setInputValue] = useState("");
  const [options, setOptions] = useState(deselectedOptions);
  const { data, refetch, isLoading, isError, isFetching, error } =
    useFetchOrdersQuery<any>({
      limit: params.get("limit"),
      tag: params.get("tag") || "",
      status: params.get("status"),
      payment_status: params.get("payment_status") || "",
      page: params.get("page") || 1,
      dest: params.get("dest") || "",
      days: params.get("days") || "",
      query: params.get("query") || "",
      track: params.get("track") || "",
      op: params.get("op") || "GREATER",
      phone: params.get("phone_num") || "",
      couriers: params.get("courier") || "",
      bookedBy: params.get("bookedBy") || "",
      bookingTo: params.get("bookingto") || "",
      bookingFrom: params.get("bookingfrom") || "",
      deliveredTo: params.get("deliveredto") || "",
      deliveredFrom: params.get("deliveredfrom") || "",
    });

 

  useEffect(() => {
    setQueryValue(params.get("query") || "");
    const queryParams = {
      query: params.get("query"),
      track: params.get("track"),
      courier: params.get("courier"),
      status: params.get("status"),
      payment_status: params.get("payment_status"),
      bookingfrom: params.get("bookingfrom"),
      bookingto: params.get("bookingto"),
      dest: params.get("dest"),
      deliveredfrom: params.get("deliveredfrom"),
      deliveredto: params.get("deliveredto"),
      page: params.get("page") || "1",
      limit: params.get("limit") || "50",
      days: params.get("days"),
      op: params.get("op") || "GREATER",
      tag: params.get("tag"),
      bookedBy: params.get("bookedBy"),
    };
    const queryString = Object.entries(queryParams)
      .filter(([, value]) => value !== null && value !== "")
      .map(([key, value]) => `${key}=${value}`)
      .join("&");
    navigateTo(`/dashboard/orders?${queryString}`);
  }, []);

  useEffect(() => {
    const bookedByText = bookedBy?.filter((str: string) => str.trim());
    let bookedbyStr = "";
    if (bookedByText?.length > 0) {
      bookedbyStr = bookedByText?.join(",");
    }
    params.set("bookedBy", bookedbyStr);
    navigateTo({ search: params.toString() });
  }, [bookedBy]);

  // Close suggestions when clicking outside
  const suggestionsRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        suggestionsRef.current &&
        !suggestionsRef.current.contains(event.target as Node) &&
        !(event.target as HTMLElement)?.closest('.Polaris-TextField')
      ) {
        setShowSuggestions(false);
      }
    };

    if (showSuggestions) {
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [showSuggestions]);

  const handleBulkBooking = useCallback(
    async (results: CsvProcessingResult[]) => {
      try {
        const validResults = results.filter((result) => result.isValid);

        if (validResults.length === 0) {
          return;
        }

        await bulkFulfillment({
          ordersData: validResults[0].jsonData,
        });
      } catch (error) {
        console.error("Failed to send data to server:", error);
      }
    },
    []
  );

  const openModalHandler = (id: string) => {
    setTrackId(id);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const paginationChangeHandler = (page: string, limit: string) => {
    params.set("page", page);
    params.set("limit", limit);
    navigateTo(`?${params.toString()}`);
    refetch();
  };

  const handleMonthChange = useCallback(
    (month: number, year: number) => setDate({ month, year }),
    []
  );
  const handleDeliveryDateChange = useCallback(
    (month: number, year: number) => setDelivery({ month, year }),
    []
  );
  const handleStatusChange = useCallback(
    (value: string[]) => {
      params.set("status", value.toString());

      setStatus(value);
      onFilterChangeRefetchHandler();
    },
    [params]
  );
  const handlePaymentStatusChange = useCallback(
    (value: string[]) => {
      params.set("payment_status", value.toString());
      setPaymentStatus(value);
      onFilterChangeRefetchHandler();
    },
    [params]
  );

  const handleCourierChange = useCallback(
    (value: string[]) => {
      params.set("courier", value.toString());
      setCourier(value);
      onFilterChangeRefetchHandler();
    },
    [params]
  );

  const handlePhoneChange = useCallback(
    (value: string) => {
      params.set("phone_num", value);
      setPhoneNumber(value);
      onFilterChangeRefetchHandler();
    },
    [params]
  );
  const handleTagChange = useCallback(
    (value: string[]) => {
      params.set("tag", removeEmptyElements(value).toString());
      setTag(value);
      onFilterChangeRefetchHandler();
    },
    [params]
  );
  const removeTag = useCallback(() => {
    params.set("tag", "");
    setTag([]);
    onFilterChangeRefetchHandler();
  }, [params]);
  const debounceTimerRef = useRef<any | null>(null);
  const onFilterChangeRefetchHandler = useCallback(() => {
    params.set("page", "1");
    navigateTo({ search: params.toString() });
  }, [params, navigateTo]);

  const handleFiltersQueryChange = useCallback((value: string) => {
    setQueryValue(value);

    // If AI mode is on, show suggestions when typing
    if (isAiMode) {
      setShowSuggestions(value.trim().length > 0);
      return;
    }
    
    setShowSuggestions(false);

    // Normal filtering behavior
    const str = value?.trim() ? value?.replace("#", "") : value;
    params.set("query", str);
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }
    debounceTimerRef.current = setTimeout(() => {
      onFilterChangeRefetchHandler();
    }, 500);
  }, [isAiMode, params, onFilterChangeRefetchHandler]);
  const handleRemoveDate = useCallback(() => {
    params.set("bookingfrom", "");
    params.set("bookingto", "");
    setSelectedDates(null);
    onFilterChangeRefetchHandler();
  }, [params]);
  const handleRemoveDeliveryDate = useCallback(() => {
    params.set("deliveredfrom", "");
    params.set("deliveredto", "");
    setSelectedDeliveryDates(null);
    onFilterChangeRefetchHandler();
  }, [params]);
  const handleAvailabilityRemove = useCallback(() => {
    setStatus([]);
    params.set("status", "");
    onFilterChangeRefetchHandler();
  }, [params]);
  const handlePaymentStatusRemove = useCallback(() => {
    setPaymentStatus([]);
    params.set("payment_status", "");
    onFilterChangeRefetchHandler();
  }, [params]);
  const handleBookedByRemove = useCallback(() => {
    setBookedBy([]);
    params.set("bookedBy", "");
    onFilterChangeRefetchHandler();
  }, [params]);
  const handleProductTypeRemove = useCallback(() => {
    setCourier([]);
    params.set("courier", "");
    onFilterChangeRefetchHandler();
  }, [params]);
  const handleTrackNumberRemove = useCallback(() => {
    params.set("track", "");
    setTrackNumber("");
    onFilterChangeRefetchHandler();
  }, [params]);
  const handlePhoneNumberRemove = useCallback(() => {
    params.set("phone_num", "");
    setPhoneNumber("");
    onFilterChangeRefetchHandler();
  }, [params]);
  const handleDestinationRemove = useCallback(() => {
    params.set("dest", "");
    setDestination("");
    onFilterChangeRefetchHandler();
  }, [params]);
  const handleCodRemove = useCallback(() => {
    params.set("cod", "");
    setCod("");
    onFilterChangeRefetchHandler();
  }, [params]);
  const handleDaysRemove = useCallback(() => {
    params.set("days", "");
    params.set("op", "GREATER");
    setDeliveryDays("");
    setDeliveryDaysOp("GREATER");
    onFilterChangeRefetchHandler();
  }, [params, onFilterChangeRefetchHandler]);

  const escapeSpecialRegExCharacters = useCallback(
    (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
    []
  );

  const updateText = useCallback(
    (value: string) => {
      setInputValue(value);
      if (value === "") {
        setOptions(deselectedOptions);
        return;
      }
      const filterRegex = new RegExp(escapeSpecialRegExCharacters(value), "i");
      const resultOptions = deselectedOptions.filter((option: recordsTypes) =>
        option.label.match(filterRegex)
      );
      setOptions(resultOptions);
    },
    [deselectedOptions, escapeSpecialRegExCharacters]
  );

  const updateSelection = useCallback(
    (selected: string) => {
      if (bookedBy.includes(selected)) {
        setBookedBy(() => bookedBy.filter((id) => id !== selected));
      } else {
        setBookedBy((prev) => {
          if (prev?.length === 0) {
            return [selected];
          }
          return [...prev, selected];
        });
      }
    },
    [bookedBy, updateText]
  );

  const optionsMarkup =
    options.length > 0
      ? options.map((option: recordsTypes) => {
          const { label, value } = option;
          return (
            <Listbox.Option
              key={`${value}`}
              value={value}
              selected={bookedBy.includes(value)}
              accessibilityLabel={label}
            >
              {label}
            </Listbox.Option>
          );
        })
      : null;
  const bookedByFilterMarkup = (
    <div style={{ height: "max-content" }}>
      <Combobox
        allowMultiple
        activator={
          <Combobox.TextField
            prefix={<Icon source={SearchIcon} />}
            onChange={updateText}
            label='Search users'
            labelHidden
            value={inputValue}
            placeholder='Search users'
            autoComplete='off'
          />
        }
      >
        {optionsMarkup ? (
          <Listbox
            autoSelection={AutoSelection.None}
            onSelect={updateSelection}
          >
            {optionsMarkup}
          </Listbox>
        ) : null}
      </Combobox>
    </div>
  );

  const handleAiModeToggle = useCallback(() => {
    setIsAiMode((prev) => {
      const newMode = !prev;
      if (newMode) {
        setQueryPlaceholder("Write what orders you need i.e 'orders with fulfilled status'");
        setShowSuggestions(queryValue.trim().length > 0);
      } else {
        setQueryPlaceholder("Search by order id, tracking number, destination city, status and type e.g 'merged'");
        setShowSuggestions(false);
      }
      return newMode;
    });
  }, [queryValue]);
  
  const handleSuggestionClick = useCallback((suggestion: { text: string; response: string }) => {
    setQueryValue(suggestion.text);
    setShowSuggestions(false);
  }, []);

  const applyGeneratedFilters = useCallback((filterData: any) => {
 
    
    const filters = filterData.filter || {};
    
    // Create a FRESH URLSearchParams - replace all existing filters
    const newParams = new URLSearchParams();
    
    // Clear all filter states first
    setStatus([]);
    setPaymentStatus([]);
    setCourier([]);
    setTag([]);
    setTrackNumber("");
    setPhoneNumber("");
    setDestination("");
    setDeliveryDays("");
    setDeliveryDaysOp("GREATER");
    setSelectedDates(null);
    setSelectedDeliveryDates(null);
    setCod("");
    setBookedBy([]);

    // Apply status filter
    if (filters.status && Array.isArray(filters.status) && filters.status.length > 0) {
      newParams.set("status", filters.status.join(","));
      setStatus(filters.status);
    }

    // Apply payment_status filter
    if (filters.payment_status && Array.isArray(filters.payment_status) && filters.payment_status.length > 0) {
      newParams.set("payment_status", filters.payment_status.join(","));
      setPaymentStatus(filters.payment_status);
    }

    // Apply courier filter
    if (filters.courier && Array.isArray(filters.courier) && filters.courier.length > 0) {
      newParams.set("courier", filters.courier.join(","));
      setCourier(filters.courier);
    }

    // Apply tag filter
    if (filters.tag && Array.isArray(filters.tag) && filters.tag.length > 0) {
      newParams.set("tag", filters.tag.join(","));
      setTag(filters.tag);
    }

    // Apply track number
    if (filters.track && filters.track.trim()) {
      newParams.set("track", filters.track.trim());
      setTrackNumber(filters.track.trim());
    }

    // Apply phone number
    if (filters.phone_num && filters.phone_num.trim()) {
      newParams.set("phone_num", filters.phone_num.trim());
      setPhoneNumber(filters.phone_num.trim());
    }

    // Apply destination city
    if (filters.dest && filters.dest.trim()) {
      newParams.set("dest", filters.dest.trim());
      setDestination(filters.dest.trim());
    }

    // Apply COD
    if (filters.cod && filters.cod.trim()) {
      newParams.set("cod", filters.cod.trim());
      setCod(filters.cod.trim());
    }

    // Apply delivery days
    if (filters.days && filters.days.trim()) {
      newParams.set("days", filters.days.trim());
      setDeliveryDays(filters.days.trim());
    }

    // Apply delivery days operator
    if (filters.op && filters.op.trim()) {
      newParams.set("op", filters.op.trim());
      setDeliveryDaysOp(filters.op.trim());
    }

    // Apply booking date range
    if (filters.bookingfrom && filters.bookingto) {
      newParams.set("bookingfrom", filters.bookingfrom);
      newParams.set("bookingto", filters.bookingto);
      const bookingStart = new Date(filters.bookingfrom);
      const bookingEnd = new Date(filters.bookingto);
      setSelectedDates({
        start: bookingStart,
        end: bookingEnd,
      });
      // Update month/year for date picker
      setDate({ month: bookingStart.getMonth(), year: bookingStart.getFullYear() });
    }

    // Apply delivery date range
    if (filters.deliveredfrom && filters.deliveredto) {
      newParams.set("deliveredfrom", filters.deliveredfrom);
      newParams.set("deliveredto", filters.deliveredto);
      const deliveryStart = new Date(filters.deliveredfrom);
      const deliveryEnd = new Date(filters.deliveredto);
      setSelectedDeliveryDates({
        start: deliveryStart,
        end: deliveryEnd,
      });
      // Update month/year for date picker
      setDelivery({ month: deliveryStart.getMonth(), year: deliveryStart.getFullYear() });
    }

    // Apply general query
    if (filters.query && filters.query.trim()) {
      newParams.set("query", filters.query.trim());
      setQueryValue(filters.query.trim());
    }

    // Set default page and limit
    newParams.set("page", "1");
    newParams.set("limit", "50");
    
    const finalParamsString = newParams.toString();

    navigateTo({ search: finalParamsString });
    // Note: RTK Query will automatically refetch when params change
  }, [
    navigateTo,
    setStatus,
    setPaymentStatus,
    setCourier,
    setTag,
    setTrackNumber,
    setPhoneNumber,
    setDestination,
    setDeliveryDays,
    setDeliveryDaysOp,
    setSelectedDates,
    setSelectedDeliveryDates,
    setQueryValue,
    setDate,
    setDelivery,
    setCod,
    setBookedBy,
  ]);

  const [aiFilterGenerator, { isLoading: isGeneratingFiltersMutation }] = useAiFilterGeneratorMutation();

  const handleGenerateFilters = useCallback(async () => {
    if (!queryValue.trim() || !isAiMode) return;

    try {
      const data = await aiFilterGenerator({
        userInput: queryValue,
        currentDate: new Date().toDateString(),
      }).unwrap();

      if (data.filter) {
        applyGeneratedFilters(data);
        setTimeout(() => {
          setQueryValue("");
          setIsAiMode(false);
          setShowSuggestions(false);
          setQueryPlaceholder("Search by order id, tracking number, destination city, status and type e.g 'merged'");
          dispatch(
            showToast({
              message: "Filters applied successfully!",
              error: false,
              visible: true,
            })
          );
        }, 100);
      } else {
        dispatch(
          showToast({
            message: "No filters received from AI",
            error: true,
            visible: true,
          })
        );
      }
    } catch (error: any) {
      const message =
        error?.data?.error || error?.message || "Failed to generate filters. Please try again.";
      dispatch(
        showToast({
          message,
          error: true,
          visible: true,
        })
      );
    }
  }, [queryValue, isAiMode, applyGeneratedFilters, dispatch, aiFilterGenerator]);

  const isGeneratingFilters = isGeneratingFiltersMutation;

  const handleFiltersClearAll = useCallback(() => {
    // Clear all filter states
    setStatus([]);
    setPaymentStatus([]);
    setCourier([]);
    setTag([]);
    setTrackNumber("");
    setPhoneNumber("");
    setDestination("");
    setDeliveryDays("");
    setDeliveryDaysOp("GREATER");
    setSelectedDates(null);
    setSelectedDeliveryDates(null);
    setCod("");
    setBookedBy([]);
    setQueryValue("");
    
    // Navigate to clean URL with just page and limit
    navigateTo("/dashboard/orders?page=1&limit=50");
  }, [
    navigateTo,
    setStatus,
    setPaymentStatus,
    setCourier,
    setTag,
    setTrackNumber,
    setPhoneNumber,
    setDestination,
    setDeliveryDays,
    setDeliveryDaysOp,
    setSelectedDates,
    setSelectedDeliveryDates,
    setCod,
    setBookedBy,
    setQueryValue,
  ]);

  const filters = [
    {
      key: "status",
      label: "Status",
      filter: (
        <ChoiceList
          title='Status'
          titleHidden
          choices={[
            { label: "FULFILLED", value: "FULFILLED" },
            { label: "INPROCESS", value: "INPROCESS" },
            { label: "DELIVERED", value: "DELIVERED" },
            { label: "CANCELLED", value: "CANCELLED" },
            { label: "RTS", value: "RTS" },
          ]}
          selected={status || []}
          onChange={handleStatusChange}
          allowMultiple
        />
      ),
      shortcut: true,
    },
    {
      key: "payment_status",
      label: "Payment Status",
      filter: (
        <ChoiceList
          title='Payment Status'
          titleHidden
          choices={[
            { label: "UNPAID", value: "UNPAID" },
            { label: "PAID", value: "PAID" },
          ]}
          selected={paymentStatus || []}
          onChange={handlePaymentStatusChange}
          allowMultiple
        />
      ),
      shortcut: true,
    },
    {
      key: "bookedBy",
      label: "Booked by",
      filter: bookedByFilterMarkup,
      shortcut: true,
    },

    {
      key: "tag",
      label: "Tag",
      filter: (
        <ChoiceList
          title='Tag'
          titleHidden
          choices={[{ label: "MERGED", value: "MERGED" }]}
          selected={removeEmptyElements(tag) || []}
          onChange={handleTagChange}
          allowMultiple
        />
      ),
      shortcut: true,
    },
    {
      key: "courier",
      label: "Courier",
      filter: (
        <ChoiceList
          title='Product type'
          titleHidden
          choices={[
            { label: "LEOPARD", value: "LEOPARD" },
            { label: "MNP", value: "MNP" },
            { label: "POSTEX", value: "POSTEX" },
            { label: "TRAX", value: "TRAX" },
          ]}
          selected={courier || []}
          onChange={handleCourierChange}
          allowMultiple
        />
      ),
      shortcut: true,
    },
    {
      key: "track_number",
      label: "Track #",
      filter: (
        <TextField
          value={track_number}
          onChange={(val) => {
            params.set("track", val);
            setTrackNumber(val);
            onFilterChangeRefetchHandler();
          }}
          autoComplete='Off'
          labelHidden
          label='track number'
        />
      ),
    },
    {
      key: "phone_num",
      label: "Phone number",
      filter: (
        <TextField
          value={phoneNumber}
          onChange={handlePhoneChange}
          autoComplete='Off'
          labelHidden
          label='Phone number'
        />
      ),
    },
    {
      key: "days",
      label: "Delivery days",
      filter: (
        <TextField
          value={deliveryDays}
          type='number'
          onChange={(val) => {
            params.set("days", val);
            setDeliveryDays(val);
            onFilterChangeRefetchHandler();
          }}
          autoComplete='Off'
          connectedRight={
            <Select
              label='delivery days'
              labelHidden
              options={[
                { label: "Select operator", value: "" },
                { label: "Greater than", value: "GREATER" },
                { label: "Less than", value: "LESS" },
                { label: "Equal", value: "EQUAL" },
              ]}
              onChange={(val) => {
                params.set("op", val);
                setDeliveryDaysOp(val);
                onFilterChangeRefetchHandler();
              }}
              value={deliveryDaysOp}
            />
          }
          labelHidden
          label='delivery days'
        />
      ),
    },
    {
      key: "dest",
      label: "Destination city",
      filter: (
        <TextField
          value={dest}
          onChange={(val) => {
            params.set("dest", val);
            setDestination(val);
            onFilterChangeRefetchHandler();
          }}
          autoComplete='Off'
          labelHidden
          label='track number'
        />
      ),
    },
    {
      key: "booking_date",
      label: "Order booking date",
      filter: (
        <DatePicker
          month={month}
          year={year}
          onChange={(dt) => {
            params.set("bookingfrom", dt.start.toDateString());
            params.set("bookingto", dt.end.toDateString());

            setSelectedDates(dt);
            onFilterChangeRefetchHandler();
          }}
          onMonthChange={handleMonthChange}
          selected={selectedDates}
          multiMonth
          allowRange
        />
      ),
    },
    {
      key: "delivered_date",
      label: "Order delivered date",
      filter: (
        <DatePicker
          month={dmonth}
          year={dyear}
          onChange={(dd) => {
            params.set("deliveredfrom", dd.start.toDateString());
            params.set("deliveredto", dd.end.toDateString());
            setSelectedDeliveryDates(dd);
            onFilterChangeRefetchHandler();
          }}
          onMonthChange={handleDeliveryDateChange}
          selected={selectedDeliveryDates}
          multiMonth
          allowRange
        />
      ),
    },
  ];
  const statuses = params.get("status") || "";
  const payment_status = params.get("payment_status") || "";
  const track_num = params.get("track") || "";
  const courier_array: any = params.get("courier") || [];
  const dest_city = params.get("dest") || "";
  const bookingFrom = params.get("bookingfrom");
  const bookingto = params.get("bookingto");
  const deliveredfrom = params.get("deliveredfrom");
  const deliveredto = params.get("deliveredto");
  const days = params.get("days") || "";
  const op = params.get("op") || "";
  const tags = params.get("tag") || "";
  const phonenum = params.get("phone_num") || "";
  const bookedByStr = params.get("bookedBy") || "";
  const theme = localStorage.getItem("theme") || "light";
  if (!isEmptyString(statuses)) {
    const key = "status";
    appliedFilters.push({
      key,
      label: "Status : " + disambiguateLabel(key, statuses?.split(",") || []),
      onRemove: handleAvailabilityRemove,
    });
  }
  if (!isEmptyString(payment_status)) {
    const key = "payment_status";
    appliedFilters.push({
      key,
      label:
        "Payment Status : " +
        disambiguateLabel(key, payment_status?.split(",") || []),
      onRemove: handlePaymentStatusRemove,
    });
  }

  if (!isEmptyString(bookedByStr)) {
    const selectedUsers = childAccounts?.filter((user: UserStr) =>
      bookedByStr?.split(",")?.includes(user?._id)
    );

    const key = "bookedBy";
    appliedFilters.push({
      key,
      label:
        "Booked by : " +
        disambiguateLabel(
          key,
          selectedUsers?.length > 0
            ? selectedUsers.map(
                (user: UserListFiltersType) =>
                  ` ${user?.first_name} ${user?.last_name}`
              )
            : []
        ),
      onRemove: handleBookedByRemove,
    });
  }
  if (!isEmptyString(tags)) {
    const key = "tag";
    appliedFilters.push({
      key,
      label: "Tag : " + disambiguateLabel(key, tags?.split(",") || []),
      onRemove: removeTag,
    });
  }

  if (!isEmptyString(days)) {
    const key = "days";
    appliedFilters.push({
      key,
      label: `Delivery : ${days}`,
      onRemove: handleDaysRemove,
    });
  }
  if (!isEmptyString(phonenum)) {
    const key = "phone_num";
    appliedFilters.push({
      key,
      label: `Phone : ${phonenum}`,
      onRemove: handlePhoneNumberRemove,
    });
  }
  if (!isEmptyString(op)) {
    const key = "op";
    appliedFilters.push({
      key,
      label: `Days condition : ${deliveryDaysOp}`,
      onRemove: handleDaysRemove,
    });
  }

  if (!isEmpty(courier_array)) {
    const key = "courier";
    appliedFilters.push({
      key,
      label: `Courier : ${disambiguateLabel(
        key,
        courier_array?.split(",") || []
      )}`,
      onRemove: handleProductTypeRemove,
    });
  }
  if (!isEmptyString(track_num)) {
    const key = "track_number";
    appliedFilters.push({
      key,
      label: `Tracking number : ${track_num}`,
      onRemove: handleTrackNumberRemove,
    });
  }
  if (!isEmptyString(cod)) {
    const key = "cod";
    appliedFilters.push({
      key,
      label: `COD : ${cod}`,
      onRemove: handleCodRemove,
    });
  }
  if (!isEmptyString(dest_city)) {
    const key = "dest";
    appliedFilters.push({
      key,
      label: `City : ${dest_city}`,
      onRemove: handleDestinationRemove,
    });
  }

  if (bookingFrom && bookingto) {
    const bookingFromTrimmed = bookingFrom.trim();
    const bookingtoTrimmed = bookingto.trim();
    if (bookingFromTrimmed && bookingtoTrimmed) {
      try {
        const booking_from = new Date(bookingFromTrimmed);
        const booking_to = new Date(bookingtoTrimmed);
        // Check if dates are valid
        if (!isNaN(booking_from.getTime()) && !isNaN(booking_to.getTime())) {
          const key = "booking_date";
          appliedFilters.push({
            key,
            label: `Booking Date : ${booking_from.toDateString()} to ${booking_to.toDateString()}`,
            onRemove: handleRemoveDate,
          });
        }
      } catch (error) {
        console.error("Error parsing booking dates:", error);
      }
    }
  }
  if (deliveredfrom && deliveredto) {
    const deliveredfromTrimmed = deliveredfrom.trim();
    const deliveredtoTrimmed = deliveredto.trim();
    if (deliveredfromTrimmed && deliveredtoTrimmed) {
      try {
        const deliver_from = new Date(deliveredfromTrimmed);
        const deliver_to = new Date(deliveredtoTrimmed);
        // Check if dates are valid
        if (!isNaN(deliver_from.getTime()) && !isNaN(deliver_to.getTime())) {
          const key = "delivered_date";
          appliedFilters.push({
            key,
            label: `Delivery Date : ${deliver_from.toDateString()} to ${deliver_to.toDateString()}`,
            onRemove: handleRemoveDeliveryDate,
          });
        }
      } catch (error) {
        console.error("Error parsing delivery dates:", error);
      }
    }
  }

  if (bulkFullfillmentSuccess) {
    dispatch(
      showToast({
        message: bulkFullFillmentData?.msg,
        error: false,
        visible: true,
      })
    );
  }

  const renderOrders = () => {
    return data?.data.map(
      ({
        _id,
        tracking_number,
        booking_date,
        booked_packet_status,
        payment_status,
        destination_city,
        delivered_date,
        tracking_account,
        order_name,
        cod,
        createdAt,
        booked_by,
        tag,
      }: any) => (
        <IndexTable.Row
          id={_id}
          key={_id}
          position={_id}
          onClick={() => openModalHandler(tracking_number)}
          tone={`${booked_packet_status === "CANCELLED" && "subdued"}` as any}
        >
          <IndexTable.Cell>
            <p style={{ maxWidth: "179px", textWrap: "wrap" }}>
              <Text
                variant='bodyMd'
                fontWeight='bold'
                as='span'
                textDecorationLine={
                  `${
                    booked_packet_status === "CANCELLED" && "line-through"
                  }` as any
                }
              >
                {order_name}
              </Text>
            </p>
          </IndexTable.Cell>
          <IndexTable.Cell>{tracking_number}</IndexTable.Cell>
          <IndexTable.Cell className='line'>
            <Badge
              tone={
                tracking_account?.company === "LEOPARD"
                  ? "info"
                  : tracking_account?.company === "MNP"
                  ? "magic"
                  : "success"
              }
            >
              {tracking_account?.company}
            </Badge>
          </IndexTable.Cell>
          <IndexTable.Cell>
            {createdAt ? formatDate(createdAt) : "N/A"}
          </IndexTable.Cell>
          <IndexTable.Cell>{cod}</IndexTable.Cell>
          <IndexTable.Cell className='capitalize'>
            {destination_city}
          </IndexTable.Cell>
          <IndexTable.Cell>
            <Badge
              progress={
                booked_packet_status === "DELIVERED"
                  ? "complete"
                  : booked_packet_status === "CANCELLED"
                  ? "complete"
                  : booked_packet_status === "FULFILLED"
                  ? "incomplete"
                  : "partiallyComplete"
              }
              tone={
                booked_packet_status === "DELIVERED"
                  ? "success"
                  : booked_packet_status === "CANCELLED" ||
                    booked_packet_status === "RTS"
                  ? "critical"
                  : "enabled"
              }
            >
              {booked_packet_status}
            </Badge>
          </IndexTable.Cell>
          <IndexTable.Cell>
            <Badge
              tone={payment_status === "PAID" ? "success" : "new"}
              size='small'
            >
              {payment_status || "UNPAID"}
            </Badge>
          </IndexTable.Cell>
          <IndexTable.Cell>
            {delivered_date ? formatDate(delivered_date) : "N/A"}
          </IndexTable.Cell>
          <IndexTable.Cell>
            {booked_by?.tag && (
              <Badge tone='new' icon={PersonIcon}>
                {booked_by?.tag}
              </Badge>
            )}
          </IndexTable.Cell>
          <IndexTable.Cell>
            {delivered_date
              ? dayjs(delivered_date).diff(dayjs(booking_date), "day")
              : "N/A"}
          </IndexTable.Cell>
          <IndexTable.Cell>
            <Button
              onClick={() => navigateTo(`/track/${tracking_number}`)}
              variant={theme === "dark" ? "secondary" : "primary"}
              size='micro'
              accessibilityLabel='order tracking button'
            >
              Track
            </Button>
          </IndexTable.Cell>
          <IndexTable.Cell>
            {booked_packet_status !== "CANCELLED" &&
              booked_packet_status !== "DELIVERED" && (
                <CancelBooking
                  tracking_number={tracking_number}
                  company={tracking_account?.company}
                />
              )}
          </IndexTable.Cell>
          <IndexTable.Cell>
            {booked_packet_status !== "CANCELLED" &&
              booked_packet_status !== "DELIVERED" && (
                <Badge
                  tone={
                    `${
                      dayjs().diff(dayjs(booking_date), "day") > 3
                        ? "critical"
                        : ""
                    }` as any
                  }
                >
                  {booking_date
                    ? dayjs()
                        .startOf("day")
                        .diff(dayjs(booking_date).startOf("day"), "day")
                    : ("N/A" as any)}
                </Badge>
              )}
          </IndexTable.Cell>
          <IndexTable.Cell>
            {tag && <Badge progress='complete'>{tag}</Badge>}
          </IndexTable.Cell>
        </IndexTable.Row>
      )
    );
  };
  if (isError) {
    return (
      <Page title='Orders'>
        <Banner icon={AlertTriangleIcon} tone='warning'>
          {error?.data?.errors[0].msg}
        </Banner>
      </Page>
    );
  }
  return (
    <>
      <Page
        title='Orders'
        fullWidth
        secondaryActions={
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: ".5rem",
            }}
          >
            <div>
              <RefreshButton
                isLoading={isFetching}
                refetch={refetch}
                tooltipContent='Refresh orders'
              />
            </div>
            {/* <div>
              <ImportOrders
                isSuccess={importOrdersIsSuccess}
                isError={importOrdersFailed}
                isLoading={importOrdersLoading}
                onProcessingComplete={handleBulkBooking}
                onError={(error) => console.error("Processing error:", error)}
                buttonText='Bulk Fulfillment'
                modalText='Upload CSV File'
                sampleLink='https://bookease-sample.s3.ap-southeast-1.amazonaws.com/Bookease+Sample+Data.csv'
              />
            </div> */}
            <div>
              <Button
                variant='secondary'
                icon={ExportIcon}
                onClick={() => setOpenExportOrdersModal((prev) => !prev)}
              >
                Export
              </Button>
            </div>
          </div>
        }
        backAction={{
          onAction: () => {
            navigateTo(-1);
          },
        }}
      >
        <AppModal />

        <ModalComponent
          heading={"Order Tracking Info"}
          type={trackId && "TRACKING"}
          open={modalOpen}
          text={"Order Tracking Info"}
          key={Math.random()}
          close={closeModal}
          id={trackId}
        />

        <>
          <BlockStack gap='200'>
            <LegacyCard>
              <div style={{ position: "relative" }}>
                <div style={{ 
                  position: "relative",
                  border: isAiMode ? "2px solid #0066cc" : "none",
                  borderRadius: "8px",
                  padding: isAiMode ? "2px" : "0",
                  transition: "all 0.3s ease",
                  boxShadow: isAiMode ? "0 0 0 3px rgba(0, 102, 204, 0.1)" : "none",
                  marginBottom: isAiMode && showSuggestions ? "200px" : "0"
                }}>
                  <IndexFilters
                    key={location.search}
                    sortOptions={[]}
                    sortSelected={sortSelected}
                    queryValue={queryValue}
                    queryPlaceholder={queryPlaceholder}
                    
                    onQueryChange={handleFiltersQueryChange}
                    onQueryClear={() => {
                      if (!isAiMode) {
                        params.set("query", "");
                        setQueryValue("");
                        onFilterChangeRefetchHandler();
                      } else {
                        setQueryValue("");
                      }
                    }}

                    onSort={setSortSelected}
                    tabs={[]}
                    selected={selected}
                    borderlessQueryField
                    onSelect={setSelected}
                    canCreateNewView
                    onCreateNewView={async () => true}
                    filters={filters}
                    appliedFilters={appliedFilters}
                    onClearAll={handleFiltersClearAll}
                    autoFocusSearchField={false}
                    mode={mode}
                    setMode={setMode}
                  />
                  <div
                    style={{
                      position: "absolute",
                      right: "7px",
                      top: "46px",
                      zIndex: 10,
                      pointerEvents: "auto",
                    }}
                  >
                    {/* <GenerateButton 
                      onClick={isAiMode ? handleGenerateFilters : handleAiModeToggle}
                      disabled={isGeneratingFilters || (isAiMode && !queryValue.trim())}
                      isAiMode={isAiMode}
                      isLoading={isGeneratingFilters}
                    /> */}
                  </div>
                  {isAiMode && (
                    <div
                      style={{
                        position: "absolute",
                        right: "7px",
                        top: "10px",
                        zIndex: 10,
                        pointerEvents: "none",
                      }}
                    >
                      <span
                        style={{
                          display: "inline-block",
                          padding: "2px 8px",
                          borderRadius: "4px",
                          fontSize: "11px",
                          fontWeight: "500",
                          backgroundColor: "#0066cc",
                          color: "white",
                          animation: "pulse 2s ease-in-out infinite",
                        }}
                      >
                        ✨ AI Mode Active
                      </span>
                    </div>
                  )}
                </div>
                {isAiMode && showSuggestions && (
                  <div
                    ref={suggestionsRef}
                    className="ai-suggestions-dropdown"
                    style={{
                      position: "absolute",
                      top: "calc(100% + 4px)",
                      left: isAiMode ? "2px" : "0",
                      right: isAiMode ? "2px" : "0",
                      zIndex: 1000,
                      maxHeight: "300px",
                      overflowY: "auto",
                    }}
                  >
                    <div className="ai-suggestions-container" style={{ padding: "8px" }}>
                      <div
                        className="ai-suggestions-header"
                        style={{
                          fontSize: "11px",
                          fontWeight: "600",
                          padding: "8px 12px",
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                        }}
                      >
                        💡 Suggestions
                      </div>
                      {suggestions.map((suggestion, index) => (
                        <div
                          key={index}
                          className="ai-suggestion-item"
                          onClick={() => handleSuggestionClick(suggestion)}
                          style={{
                            padding: "10px 12px",
                            cursor: "pointer",
                            borderBottom: index < suggestions.length - 1 ? "1px solid #f1f3f5" : "none",
                            transition: "background-color 0.2s",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                          title={suggestion.response}
                        >
                          <span className="ai-suggestion-icon" style={{ fontSize: "14px" }}>✨</span>
                          <span className="ai-suggestion-text" style={{ fontSize: "13px" }}>{suggestion.text}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </LegacyCard>
            <LegacyCard>
              <IndexTable
                resourceName={{ singular: "order", plural: "orders" }}
                loading={isLoading || isFetching}
                itemCount={
                  isLoading || isFetching ? 1 : data?.data?.length || 0
                }
                selectable={false}
                headings={[
                  {
                    title: "Order id",
                    
                    tooltipContent: (
                      <p
                        style={{
                          textAlign: "center",
                          fontSize: "14px",
                          lineHeight: 1,
                        }}
                      >
                        Order id given by shopify
                      </p>
                    ),
                    tooltipWidth: "default",
                  },
                  {
                    title: "Track number",
                  },

                  {
                    title: "Courier",
                  },
                  {
                    title: "Booking date",
                    tooltipContent: (
                      <p
                        style={{
                          textAlign: "center",
                          fontSize: "14px",
                          lineHeight: 1,
                        }}
                      >
                        When order was booked
                      </p>
                    ),
                    tooltipWidth: "default",
                  },
                  {
                    title: "Cash on delivery",
                    tooltipContent: (
                      <p
                        style={{
                          textAlign: "center",
                          fontSize: "14px",
                          lineHeight: 1,
                        }}
                      >
                        Cash of delivery amount
                      </p>
                    ),
                    tooltipWidth: "default",
                  },
                  {
                    title: "Destination",
                  },
                  {
                    title: "Status",
                    tooltipContent: (
                      <p
                        style={{
                          textAlign: "center",
                          fontSize: "14px",
                          lineHeight: 1,
                        }}
                      >
                        Generalized status
                      </p>
                    ),
                    tooltipWidth: "default",
                  },
                  {
                    title: "Payment Status",
                  },
                  {
                    title: "Delivered date",
                    tooltipContent: (
                      <p
                        style={{
                          textAlign: "center",
                          fontSize: "14px",
                          lineHeight: 1,
                        }}
                      >
                        The day when parcel is delivered
                      </p>
                    ),
                    tooltipWidth: "default",
                  },
                  {
                    title: "Booked by",
                  },
                  {
                    title: "Days",
                    tooltipContent: (
                      <p
                        style={{
                          textAlign: "center",
                          fontSize: "14px",
                          lineHeight: 1,
                        }}
                      >
                        Number of days from booking till delivery
                      </p>
                    ),
                    tooltipWidth: "default",
                  },
                  {
                    title: "Track",
                    tooltipContent: "Track your order live",
                    tooltipWidth: "default",
                  },
                  {
                    title: "Cancel",
                    tooltipContent:
                      "This will cancel booking and mark as unfulfilled",
                    tooltipWidth: "wide",
                  },
                  {
                    title: "Booked days",
                  },
                  {
                    title: "Tags",
                  },
                ]}
              >
                {renderOrders()}
              </IndexTable>
            </LegacyCard>
          </BlockStack>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "1rem 0px",
            }}
          >
            {!isLoading ? (
              <GeneralPagination
                currentPage={data?.page}
                onPageChange={paginationChangeHandler}
                total={data?.totalOrders}
                totalPages={data?.totalPages}
                limit={data?.pagination?.limit}
                key={Math.random()}
                itemName='orders'
              />
            ) : (
              <div style={{ width: "300px" }}>
                <SkeletonDisplayText
                  size='large'
                  maxWidth='100%'
                ></SkeletonDisplayText>
              </div>
            )}
          </div>
          <ExportOrderModal
            openExportOrdersModal={openExportOrdersModal}
            closeModal={() => setOpenExportOrdersModal(false)}
            orders={data?.totalOrders}
          />
        </>
      </Page>
    </>
  );

  function disambiguateLabel(key: string, value: string[]): string {
    switch (key) {
      case "status":
        return `${value}`;
      case "courier":
        return value.map((val) => `${val}`).join(", ");
      case "productType":
        return value.join(" ");
      default:
        return value.toString();
    }
  }

  function isEmpty(value: string | string[]): boolean {
    if (Array.isArray(value)) {
      return value.length === 0;
    } else {
      return value === "" || value == null;
    }
  }
  function isEmptyString(value: string): boolean {
    return value.trim() === "";
  }
}
